import React from 'react';
import { Container } from 'reactstrap';
import ProcurementView from './ProcurementView';

const MailInbox = () => {
  document.title = 'List Planning & Procurement';
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <ProcurementView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MailInbox;
